import React, { useState, useContext, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import Table from "../../../components/Admin/Table";
import { useNavigate, useLocation } from "react-router-dom";
import "./ProjectList.css";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import {
  deleteProjectDetails,
  projectList,
  toggleProjectStatus,
} from "../../../services/projectService";
import Spinner from "../../../components/Spinner/spinner";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProjectDetails,
  clearProjectData,
} from "../../../store/slices/projectListSlice";
import { appInsights } from "../../../AppInsights";

const ProjectList = () => {
  const { userData } = useSelector(state => state.user);
  const currentUserTypeId = localStorage.getItem("userTypeId");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUserRoleId = userData?.userTypes?.find(
    (type) => type?.userTypeId == currentUserTypeId
  );

const roleId = currentUserRoleId?.userTypeRoleId

  //Ref:to filter data in table
  const [list, setList] = useState(null);
  // Access the state from the Redux store
  const { projectData, loadingFlag, error, noAccess, errorCode } = useSelector(
    (state) => state.projectList
  );
  const [searchQuery, setSearchQuery] = useState("");
  const toast = React.useRef(null);
  const [loading, setLoading] = useState(false);
  const columns = [
    { field: "projectType", header: "Project Type"},
    { field: "name", header: "Project Name" },
    {
      field: "description",
      header: "Description",
    },
    {
      field: "startDate",
      header: "Start Date",
      type: "date",
    },
    {
      field: "endDate",
      header: "End Date",
      type: "date",
    },
    {
      field: "createdBy",
      header: "Created By",

    },
  ];

  const confirmApprove = (rowData) => {

    confirmDialog({
      message: 'Are you sure you want to Delete this Project?',
      header: 'Delete Project!',
      icon: 'pi pi-info-circle delete-state-icon1',
      acceptClassName: 'p-button-danger',
      accept: () => handleDelete(rowData),
      reject: () => {}
    });
  };

  const handleDownload = (rowData) => {
  };
  

  const handleDelete = async (rowData) => {
    try {
      let result = await deleteProjectDetails(currentUserTypeId,rowData?.projectId);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: `${result}`,
        life: 5000,
        closable: true,
      });

      fetchProjects();
    } catch (error) {
      appInsights.trackException("Delete ProjectList",{ exception: error });
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || "Something went wrong at Server Side",
        life: 3000,
      });
    }
  };
  const confirmApprove1=(data,value)=>{
    confirmDialog({
      message: `Are you sure you want to ${value?'Enable':'Disable'} this Project?`,
      header: "Project Status!",
      icon: "pi pi-info-circle delete-state-icon1",
      className: "addPaddingForDialogBox",
      acceptClassName: "p-button-danger ",
      accept: () => handleStatusChange(data,value),
      reject: () => {},
    });
  }
  const handleStatusChange = async (rowData, value) => {
    try {
      let result = await toggleProjectStatus(currentUserTypeId,rowData?.projectId, value);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: `${result}`,
        life: 5000,
        closable: true,
      });
      fetchProjects();
      // TODO: add toast
    } catch (error) {
      appInsights.trackException("Post ProjectList",{ exception: error });
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || "Something went wrong at Server Side",
        life: 3000,
      });
    }
  };
  const handleView = (rowData, value) => {
  };


  const actions = {
    status: {
      label: "Status",
      enabled: true,
      onChange: confirmApprove1,
    },
    menu: {
      label: "",
      enabled: true,
      items: [
        {
          label: "Edit",
          icon: "pi pi-pencil",
          command: (data) => roleId==2?navigate(`/hr/project/${data?.projectId}`):navigate(`/admin/project/${data?.projectId}`),
        },
        {
          label: "Delete",
          icon: "pi pi-trash",
          command: (data) => confirmApprove(data),
        },
      ],
    },
    view: {
      label: "View",
      enabled: false,
      onClick: (rowData) => handleView(rowData),
    },
    download: {
      label: "Download",
      enabled: false,
      onClick: (rowData) => handleDownload(rowData),
    },
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <IconField iconPosition="left" className="">
          <InputIcon
            id={"search-icon"}
            className={`pi pi-search pl-1 ${searchQuery ? "hidden" : ""}`}
          />
          <InputText
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="      Search Project"
            className="w-100 search-field"
          />
        </IconField>
      </div>
    );
  };

  const tableStyle = {
    dataTable: "p-datatable-sm",
  };

  // Filter data based on search query
  const filteredData = list?.filter(
    (item) =>
      item?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item?.projectType?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item?.description?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item?.createdBy?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item?.startDate?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item?.endDate?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (searchQuery.toLowerCase() === 'active'  && item?.isActive === true) ||
      (searchQuery.toLowerCase() === 'inactive' && item?.isActive === false)
  );

   
  const fetchProjects = async () => {
    if (loadingFlag) return; // Don't make another API call if one is in progress
    try {
      await dispatch(fetchProjectDetails(currentUserTypeId));
    } catch (error) {
      appInsights.trackException("Get ProjectList",{ exception: error });
      //  TODO: add toast
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || "Something went wrong at Server Side",
        life: 3000,
      });
    }
  };

  useEffect(() => {
    if (!loadingFlag && !projectData) {
      fetchProjects(); // Fetch data if projectData doesn't exist
    }
  }, [dispatch, projectData]); // This will only run when projectData changes
  // Use another effect to watch projectData and log it when it changes
  useEffect(() => {
    if (projectData) {
      setList(projectData);
    }
  });

  return (
    <div className="timesheet-table-container p-3 border-round-xl bg-white">
      <div className="sm:flex justify-content-between px-1 align-items-center">
        <div className="flex align-items-center p-2 gap-2">
          <h2 className="employee_header font-bold m-0 pl-2 pr-3">Project List</h2>
          {list && (
            <span className="count-span pl-4 pr-4 p-2">
              {" "}
              {list?.length }{" "}
            </span>
          )}
        </div>
        <div className="pl-3">
        <Button
          label="New Project"
          icon="pi pi-plus"
             className="button-bg admin_add_btn"  onClick={() => roleId==2?navigate('/hr/project/new'):navigate('/admin/project/new')}
        />
        </div>       
      </div>
      <div className="table-container surface-section p-3 border-round-xl ">
        <Toast ref={toast} position="top-center" />
        <ConfirmDialog className="adminRejectDialog projectRejectDialog"/>
        {loadingFlag && <Spinner />}
        {!loadingFlag && (
          <Table
            content={filteredData}
            columnsData={columns}
            actions={actions}
            tableStyle={tableStyle}
            header={renderHeader}
            paginator={true}
            rows={50}
            rowsPerPageOptions={[5, 10, 25, 50]}
            emptyMessage="No projects found"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
          />
        )}
      </div>
    </div>
  );
};

export default ProjectList;
